import { render, staticRenderFns } from "./StandaloneWidget.vue?vue&type=template&id=25ce5c8d&scoped=true"
import script from "./StandaloneWidget.vue?vue&type=script&lang=js"
export * from "./StandaloneWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ce5c8d",
  null
  
)

export default component.exports